import type { Communication, Reference } from '@medplum/fhirtypes'
import { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { cn } from '@seen/ui'
import { IconMessage } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { useTimelineItemUrl } from '#src/hooks/useTimelineItemUrl.ts'

export function CommentMention({
  comment: commentReference,
  className,
}: {
  comment: Reference<Communication>
  className?: string
}): JSX.Element {
  const { data: comment } = useRead(CommentCommunication, commentReference)
  const url = useTimelineItemUrl(comment)
  const preview = getCommentPreview(comment?.message)
  return (
    <Link
      to={url}
      className={cn(
        'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 [&&]:no-underline',
        className
      )}
      tabIndex={-1}
    >
      <span className="inline-flex items-center gap-1 align-middle whitespace-nowrap">
        <IconMessage className="size-3.5 text-foreground-secondary" />
        <span>{preview || 'Comment'}</span>
      </span>
    </Link>
  )
}

function getCommentPreview(message: string | undefined): string {
  if (!message) {
    return ''
  }
  const parser = new DOMParser()
  const doc = parser.parseFromString(message, 'text/html')
  const text = doc.body.textContent?.trim() ?? ''
  if (text.length <= 60) {
    return text
  }
  return `${text.slice(0, 60).trimEnd()}…`
}
